import { axiosLocal5000Local } from "../axios";



// /portfolio_allocation_details

export async function getPortFolioAllocationDetails(date:any){
    return await axiosLocal5000Local.post(`portfolio/portfolio_allocation_details`, {
        'date' : date
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
       
    })
}


export async function getPortfolioCombinedWeightsData(s_symbol:any, startDate:any, endDate:any){
    return await axiosLocal5000Local.post(`portfolio/portfolio_combined_weight_data`, {
        's_symbol' : s_symbol,
        'startDate' : startDate,
        'endDate' : endDate
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
    })
}


export async function getSectorWeights(date:any){
    return await axiosLocal5000Local.post(`portfolio/sector_wieghts`, {
        'date':date
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
    })
}

export async function getPortfolioMetric(startDate:any, endDate:any){
    return await axiosLocal5000Local.post(`portfolio/metric_details`, {
        'startDate' : startDate,
        'endDate' : endDate
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
    })
}


export async function getReturnCompData(duration:any){
    return await axiosLocal5000Local.post(`portfolio/getReturnCompData`,{
        'duration':duration
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
    })
}

export async function getAvgMedianCompApi(duration:any){
    return await axiosLocal5000Local.post(`portfolio/getAvgMedianComp`,{
        'duration':duration
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
    })
}


export async function getReturnPos(){
    return await axiosLocal5000Local.post(`portfolio/getReturnPosibilities`).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
    })
}


//changes adedd
export async function getMarketBeatDrawdown(){
    return await axiosLocal5000Local.post(`portfolio/getMarketbeatDrawdown`).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the portfolio allocation details:", error)
        return {"error": true}
    })
}


export async function getHedgeAnalyticsDetails(api_uri:any, details:any){
    return await axiosLocal5000Local.post(`portfolio/hedgeanalytics?api_uri=${api_uri}`,details)
    .then((res:any)=>{return res?.data})
    .catch((error:any)=>{
        console.log(error);
        return{"error":true}})
}

export async function getMutualFundNames(){
    return await axiosLocal5000Local.post('portfolio/getMFNames')
    .then((res:any)=>{return res?.data})
    .catch((error:any)=>{
        console.log(error);
        return{"error":true}})
}

export async function  getMutualFundDetailsALL(startDate:any,endDate:any,amount:any,ArrMutualFund:any){
    return await axiosLocal5000Local.post(`portfolio/getMFDetailsAll`,{
        "startDate":startDate,
        "endDate":endDate,
        "amount":amount,
        "ArrMutualFund":ArrMutualFund
    })
    .then((res:any)=>{return res?.data})
    .catch((error:any)=>{
        console.log(error);
        return{"error":true}})        
}

export async function  getFeedsenseReturnALL(startDate:any,endDate:any,amount:any){
    return await axiosLocal5000Local.post(`portfolio/feedsenseReturnAll`,{
        "startDate":startDate,
        "endDate":endDate,
        "amount":amount
    })
    .then((res:any)=>{return res?.data})
    .catch((error:any)=>{
        console.log(error);
        return{"error":true}})        
}

export async function fetchHedgeM2m(startDate:any,endDate:any){
    return await axiosLocal5000Local.post(`portfolio/getHedgeM2m`,{
        "startDate":startDate,
        "endDate":endDate
    })
    .then((res:any)=>{return res?.data})
    .catch((error:any)=>{
        console.log(error);
        return{"error":true}})        
}

export async function fetchHedgeChart(){
    return await axiosLocal5000Local.post(`portfolio/getHedgeChart`)
    .then((res:any)=>{return res?.data})
    .catch((error:any)=>{
        console.log(error);
        return{"error":true}})        
}

export async function getMultiplierList(startDate:any, endDate:any){
    return await axiosLocal5000Local.post(`portfolio/getPortfolioMultiplier`,{
        "startDate":startDate,
        "endDate":endDate
    })
    .then((res:any)=>{return res?.data})
    .catch((e:any)=>{
        console.log(e);
        return {"error":true}})
}